<template>
    <v-dialog
        v-model="dialog_state"
        scrollable
        :width="confirm_options.width"
        :max-width="confirm_options.width"
        persistent
    >
        <v-card class="dialog-card">
            <v-card-title class="dialog-title-container pt-3 pb-0">
                <div v-if="confirm_options.title" class="dialog-title headline my-1">{{ confirm_options.title }}</div>
            </v-card-title>
            <v-card-text class="pb-2 my-4">
                <div
                    v-if="confirm_options.warning_text"
                    class="error lighten-2 rounded-lg pa-4 d-flex align-center mb-5"
                >
                    <div class="flex-shrink-0">
                        <icon
                            icon="AlertTriangle"
                            size="32"
                            color="error"
                        />
                    </div>
                    <div class="font-weight-medium ml-3">
                        {{ confirm_options.warning_text }}
                    </div>
                </div>
                <div v-if="confirm_options.text" class="body-1" v-html="confirm_options.text"></div> <!-- ALL HEADERS SHOULD BE STATIC TRANSLATIONS -->
                <v-row v-if="confirm_options.options" no-gutters>
                    <v-col>
                        <div v-if="confirm_options.options" class="my-1">
                            <v-checkbox
                                v-for="(opt, index) in confirm_options.options"
                                :key="opt.name"
                                v-model="opt.checked"
                                :disabled="opt.disabled"
                                :class="{ 'mt-5': index === 0, 'dialog-option': true }"
                                :label="opt.text"
                                :hide-details="!opt.hints"
                                @change="option_changed($event, opt.name)"
                            ></v-checkbox>
                        </div>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="px-4 pb-4 mx-3">
                <v-spacer></v-spacer>
                <secondary-button v-if="confirm_options.cancel_text" @click="cancel()">
                    {{ confirm_options.cancel_text }}
                </secondary-button>
                <primary-button v-if="confirm_options.confirm_text2" @click="confirm2()">
                    {{ confirm_options.confirm_text2 }}
                </primary-button>
                <v-tooltip bottom :disabled="!confirm_options.action_tooltip" max-width="300">
                    <template v-slot:activator="{ on }">
                        <v-btn :disabled="!can_confirm" v-on="on" test-id="confirm-modal-confirm" class="ml-2" color="primary inverted--text" @click="confirm()">
                            {{ confirm_options.confirm_text }}
                        </v-btn>
                    </template>
                    {{ confirm_options.action_tooltip }}
                </v-tooltip>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import Vue from "vue";
import { computed, ref, watch } from "@vue/composition-api";
import DialogModule from "../../store/modules/dialog";

export default {
    name: "ConfirmDialog",
    setup() {
        const { confirm_options, confirm_open, setConfirmDialog, closeConfirmDialog } = DialogModule();
        const confirmed_options = ref([]);
        const can_confirm = ref(true);

        const dialog_state = computed({
            get: () => confirm_open.value,
            set: val => {
                setConfirmDialog(val);
            }
        });

        watch(dialog_state, function() {
            confirmed_options.value =
                confirm_options.value.options == null
                    ? []
                    : confirm_options.value.options.filter(x => x.checked).map(x => x.name);
        });

        watch(confirmed_options, function() {
            if (confirm_options.value.options && confirm_options.value.options.length) {
                const mandatory_opts = confirm_options.value.options
                    .filter(opt => !!opt.mandatory)
                    .reduce((acc, curr) => acc.concat(curr.name), []);
                const are_mandatory_opts_checked = mandatory_opts.every(i => confirmed_options.value.includes(i));

                if (mandatory_opts.length && !are_mandatory_opts_checked) {
                    can_confirm.value = false;
                } else {
                    can_confirm.value = true;
                }
            }
        });

        const confirm = function() {
            confirm_options.value.action(Vue.clone_object(confirmed_options.value));
            closeConfirmDialog();
        };
        const confirm2 = function() {
            confirm_options.value.action2(Vue.clone_object(confirmed_options.value));
            closeConfirmDialog();
        };
        const cancel = function() {
            if (confirm_options.value.cancel != null) confirm_options.value.cancel();
            confirmed_options.value = [];
            closeConfirmDialog();
        };
        const option_changed = function(checked, val) {
            if (checked) {
                if (confirmed_options.value.indexOf(val) === -1) confirmed_options.value.push(val);
            } else {
                if (confirmed_options.value.indexOf(val) >= 0)
                    confirmed_options.value.splice(confirmed_options.value.indexOf(val), 1);
            }
        };
        return {
            dialog_state,
            confirm_options,
            confirm,
            confirm2,
            cancel,
            option_changed,
            can_confirm
        };
    }
};
</script>
<style scoped>
.dialog-title-container {
    word-break: normal;
}
</style>
